<template>
  <div class="social-fixed" :class="{ visible: isVisible }">
    <a
      href="https://www.facebook.com/people/Al-Furqan-Academy/61578066607647/"
      target="_blank"
      class="icon facebook"
      aria-label="Facebook"
    >
      <font-awesome-icon :icon="['fab', 'facebook-f']" />
    </a>
    <a
      href="https://www.tiktok.com/@furqanacademy101?_t=ZS-8xE1tXqCpPd&_r=1"
      target="_blank"
      class="icon tiktok"
      aria-label="TikTok"
    >
      <font-awesome-icon :icon="['fab', 'tiktok']" />
    </a>
    <a
      href="https://www.youtube.com/@alfurqanacademy-k6t"
      target="_blank"
      class="icon youtube"
      aria-label="YouTube"
    >
      <font-awesome-icon :icon="['fab', 'youtube']" />
    </a>
  </div>
</template>

<script>
export default {
  name: "SocialMediaLinks",
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    },
  },
};
</script>

<style scoped lang="scss">
.social-fixed {
  position: fixed;
  top: 50%;
  left: 10px;
  transform: translateY(-50%) translateX(-50px); // Start off hidden to the left
  display: flex;
  flex-direction: column;
  gap: 15px;
  opacity: 0;
  z-index: 1000;
  transition: transform 0.6s ease, opacity 0.6s ease; // ✅ here the transitions

  &.visible {
    transform: translateY(-50%) translateX(0); // enter its natural position
    opacity: 1;
  }

  a.icon {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 1.4rem;
    color: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
  }

  .facebook {
    background-color: #1877f2;
  }
  .tiktok {
    background-color: #000;
  }
  .youtube {
    background-color: #ff0000;
  }

  @media (max-width: 1024px) {
    a.icon {
      width: 40px;
      height: 40px;
      font-size: 1.2rem;
    }
  }

  @media (max-width: 768px) {
    a.icon {
      width: 35px;
      height: 35px;
      font-size: 1rem;
    }
  }
}
</style>
